export default "__VITE_ASSET__axzvnBuB__"